import { IoIosSearch } from "react-icons/io";
import { cn } from "../../utility/utils";

const SearchBar = ({ value, onChange, disabled, className, placeholder="Search by name..." }) => {
  return (
    <div
      className={cn(
        " flex items-center w-full bg-gray-200 rounded-lg px-3 py-1 space-x-2 ",
        className
      )}
    >
      <IoIosSearch className="w-8 h-8 text-primary-shade-2" />
      <input
        type="search"
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        name="search_query"
        className="w-full outline-none bg-gray-200"
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBar;
